import React from 'react'
import { Button, Callout } from '@superhi/design'

import { EDITOR_URL } from 'src/config'

const EditorCallout: React.FC<React.PropsWithChildren<unknown>> = () => (
  <Callout
    title="Want to try out the SuperHi Editor? Just sign up to SuperHi and you’re ready to make your own sites!"
    backgroundColor="pink"
  >
    <Button level={Callout.ButtonLevel} href={EDITOR_URL} isExternal>
      Sign up now
    </Button>
  </Callout>
)

export default EditorCallout
